import { createFileRoute } from '@tanstack/react-router'
import { Privacidade } from '@/features/portal/privacidade'
import { PortalShell } from '@/features/portal/shell'

/** Termos com versão e data, e os direitos sobre os próprios dados. */
export const Route = createFileRoute('/_portal/portal_/privacidade')({
  component: function PrivacidadeDoPortal() {
    return (
      <PortalShell title="Privacidade">
        <Privacidade />
      </PortalShell>
    )
  },
})
